import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const DataTypePersonPillWrapper = styled.div`
  width: fit-content;
  display: inline;
  padding: 2px 6px;
  background: rgba(255, 210, 95, 0.2);
  border-radius: 8px;

  transition: background 200ms ease-in-out;
  &:hover {
    background: rgba(255, 210, 95, 0.4);
  }

  & > :not(:last-child) {
    margin-right: 4px;
  }

  ${BREAKPOINTS.tablet} {
    padding: 2px 6px;
  }

  cursor: pointer;
  -webkit-box-decoration-break: clone;
  position: relative;
`;

export const DataTypePersonAvatarContainer = styled.div`
  display: inline;
  position: absolute;
  left: 0px;
  top: 0px;
  & img {
    margin-top: 0px !important;
  }
`;

export const DataTypePersonIconContainer = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transform: translateY(2px);
`;

interface DataTypePersonPillTextProps {
  hasProfileImage?: boolean;
}

export const DataTypePersonPillText = styled.span<DataTypePersonPillTextProps>`
  font-weight: 400;
  font-size: inherit;
  line-height: inherit;

  ${({ hasProfileImage }) =>
    hasProfileImage &&
    `
    margin-left: 21px;
  `}

  color: var(--color-text);
`;
